<template>
    <a class="btn btn-outline-secondary" :href="journeyUrl" @click="handleClick" :class="{ disabled }">
        <i class="fas fa-route"></i> {{resource('JourneyBuilder_Overview_Composer_Button_Text')}}
    </a>    
</template>

<script>
    import api from "@modules/JourneyBuilder/api";
    import resources from "@core/Util/Mixins/resources";
    
    export default {
        name: "NavigateToJourneyButton",
        
        mixins: [resources],

        props: {
            journeyId: {
                type: String,
                required: false
            },

            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {
            journeyUrl() {
                return api.getViewJourneyUrl(this.journeyId || '');
            }
        },

        methods: {
            handleClick(evt) {
                if(this.disabled) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }
            }
        }
    }
</script>
